export default {
  DE: 'Deutsch',
  EN: 'English',
  ES: 'Español',
  FR: 'Français',
  IT: 'Italiano',
  NL: 'Nederlands',
  PL: 'Polski',
  PT: 'Português',
  ZH: '中文'
};

export const LOCALE_CODE_TO_TRANSLATION = {
  de_DE: 'German',
  en_GB: 'English',
  es_ES: 'Spanish',
  fr_FR: 'French',
  it_IT: 'Italian',
  nl_NL: 'Dutch',
  pl_PL: 'Polish',
  pt_PT: 'Portuguese',
  zh_CN: 'Chinese'
};
